import React from 'react';

function EventTicker({ text, speedMs = 30000, heightPx = 48 }) {
    return (
        <div
            className="event-ticker d-flex align-items-center"
            style={{ height: `${heightPx}px` }}
            aria-live="off"
            aria-label="Upcoming events ticker"
        >
            <div className="event-ticker__track" style={{ ['--ticker-speed']: `${speedMs}ms` }}>
                {[0, 1].map((chunk) => (
                    <div className="event-ticker__chunk" key={chunk}>
                        <span className="event-ticker__segment">{text}</span>
                        <span className="event-ticker__separator" aria-hidden="true">•</span>
                        <span className="event-ticker__segment">{text}</span>
                        <span className="event-ticker__separator" aria-hidden="true">•</span>
                        <span className="event-ticker__segment">{text}</span>
                        <span className="event-ticker__separator" aria-hidden="true">•</span>
                        <span className="event-ticker__segment">{text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default EventTicker;


